import React from "react";
import styled from "@emotion/styled";
import fanduelLogo from "assets/img/fanduel.png";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {IBettingPartnerController} from "views/components/betting_partner/betting_partner.controller";

const Wrapper = styled.a`
	background: rgba(48, 47, 49, 0.08);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;

	gap: 4px;
	padding: 0 13px;
	max-width: 142px;
	flex-grow: 0;
	flex-shrink: 0;
	width: 100%;
	span {
		color: #302f31;
		font-family: var(--fontFamilySecond);
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 16.5px */
		letter-spacing: 0.165px;
		text-transform: uppercase;
	}

	img {
		width: 100%;
	}

	@media (max-width: 615px) {
		max-width: 90px;
		padding: 0;
		span {
			font-size: 10px;
		}
	}
`;
export const BettingPartner: React.FC = observer(() => {
	const {i18n, isAllowedOdds} = useViewController<IBettingPartnerController>(
		Bindings.BettingPartnerController
	);

	if (!isAllowedOdds) {
		return null;
	}
	return (
		<Wrapper
			href={i18n.t(
				"partner.link",
				"https://canada.sportsbook.fanduel.com/en/sports/navigation/6227.1/7347.1"
			)}
			target={"_blank"}>
			<span>{i18n.t("partner.odds_by", "odds by")}</span>
			<img src={fanduelLogo} alt="Partner" />
		</Wrapper>
	);
});
